import { render, staticRenderFns } from "./TermsOfServiceText.vue?vue&type=template&id=4306c97e&scoped=true&"
import script from "./TermsOfServiceText.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServiceText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306c97e",
  null
  
)

export default component.exports